import { generateVuexCrud } from '@/utilities/crud/vuex';

const crud = generateVuexCrud('customerOrigin');

export const state = {
    ...crud.state,
};

export const actions = {
    ...crud.actions,
};

export const mutations = {
    ...crud.mutations,
};

export default {
    state,
    actions,
    mutations,
};
